import { InternetService } from '@common/lib/api';
import * as internet from './types';

const actions = {
  // 인터넷 커머스 신청 - 사용자
  async [internet.CREATE_INTERNET_COMMERCE_ESTIMATION](context, params) {
    const { data } = await InternetService.add(params);
    return data;
  },
  // 인터넷 커머스 견적 요청 쿠폰
  async [internet.SELECT_INTERNET_COMMERCE_COUPON](context, params) {
    const { data } = await InternetService.getByUserCoupon(params);

    return data;
  },
  // 인터넷 커머스 신청 리스트 - 사용자
  async [internet.SELECT_INTERNET_COMMERCE_ESTIMATION](context, params) {
    const { data } = await InternetService.getByUserId(params);

    if (params.status == 'ING') {
      context.commit(internet.SET_INTERNET_COMMERCE_ING_LIST, data);
    } else if (params.status == 'END') {
      context.commit(internet.SET_INTERNET_COMMERCE_END_LIST, data);
    }

    return data;
  },
  // 인터넷 커머스 신청한 리스트 상세 - 사용자
  async [internet.SELECT_INTERNET_COMMERCE_DETAIL](context, params) {
    // console.log('SELECT_INTERNET_COMMERCE_DETAIL');
    console.log(params);
    const { data } = await InternetService.getById(params);

    context.commit(internet.SET_INTERNET_COMMERCE_DETAIL, data);

    return data;
  },
  async [internet.SELECT_INTERNET_COMMERCE_UUID_DETAIL](context, params) {
    // console.log('SELECT_INTERNET_COMMERCE_UUID_DETAIL');
    console.log(params);
    const { data } = await InternetService.getByUuid(params);

    context.commit(internet.SET_INTERNET_COMMERCE_DETAIL, data);

    return data;
  },
  // 인터넷 커머스 신청서 마감 - 사용자
  async [internet.UPDATE_INTERNET_COMMERCE_CLOSING](context, params) {
    // console.log('UPDATE_INTERNET_COMMERCE_CLOSING');
    console.log(params);
    const { data } = await InternetService.setClosingById(params);

    // context.commit(internet.SET_INTERNET_COMMERCE_DETAIL, data);

    return data;
  },
  // 인터넷 커머스 받은 혜택 리스트 - 사용자
  async [internet.SELECT_INTERNET_COMMERCE_USER_QUOTATION](context, params) {
    console.log('SELECT_INTERNET_COMMERCE_USER_QUOTATION');
    console.log(params);
    const { data } = await InternetService.getUserQuotation(params);

    context.commit(internet.SET_INTERNET_COMMERCE_USER_QUOTATION_LIST, data);

    return data;
  },
  // 인터넷 커머스 새로 받은 혜택 - 사용자
  async [internet.SELECT_INTERNET_COMMERCE_USER_QUOTATION_NEW](
    context,
    params,
  ) {
    console.log('SELECT_INTERNET_COMMERCE_USER_QUOTATION_NEW');
    console.log(params);
    const { data } = await InternetService.getUserQuotationNew(params);

    context.commit(
      internet.SET_INTERNET_COMMERCE_USER_QUOTATION_NEW_LIST,
      data,
    );

    return data;
  },
  // 인터넷 커머스 혜택 봤을때 처리 - 사용자
  async [internet.UPDATE_INTERNET_COMMERCE_VISIBLE](context, params) {
    console.log('UPDATE_INTERNET_COMMERCE_VISIBLE');
    console.log(params);
    const { data } = await InternetService.setUserQuotationVisible(params);

    // context.commit(internet.SET_INTERNET_COMMERCE_DETAIL, data);

    return data;
  },
  // 인터넷 커머스 제안 신청서 작성 - 사장님
  async [internet.CREATE_INTERNET_COMMERCE_QUOTATION](context, params) {
    console.log('CREATE_INTERNET_COMMERCE_QUOTATION');
    console.log(params);

    const { data } = await InternetService.createQuotation(params);
    console.log(data);
    return data;
  },
  // 인터넷 커머스 받은 신청서 리스트 - 사장님
  async [internet.SELECT_INTERNET_COMMERCE_OWNER_QUOTATION](context, params) {
    const { data } = await InternetService.getByAll(params);

    if (params.status == 'WAIT') {
      context.commit(internet.SET_INTERNET_COMMERCE_QUOTATION_ING_LIST, data);
    } else if (params.status == 'COMPLETE') {
      context.commit(internet.SET_INTERNET_COMMERCE_QUOTATION_END_LIST, data);
    }

    return data;
  },
  // 인터넷 커머스 발송완료 체크 - 사장님
  async [internet.SELECT_INTERNET_COMMERCE_QUOTATION_CNT_CHECK](
    context,
    params,
  ) {
    const { data } = await InternetService.getQuotationCntCheck(params);

    context.commit(internet.SET_INTERNET_COMMERCE_QUOTATION_CNT_CHECK, data);

    return data;
  },
  // 인터넷 커머스 신청서 보내기 - 사장님
  async [internet.CREATE_INTERNET_COMMERCE_APPLY](context, params) {
    const { data } = await InternetService.createApply(params);
    return data;
  },
  // 인터넷 커머스 신청서 상세
  async [internet.SELECT_INTERNET_COMMERCE_APPLY_DETAIL](context, params) {
    const { data } = await InternetService.getApplyDetail(params);
    context.commit(internet.SET_INTERNET_COMMERCE_APPLY_DETAIL, data);
    return data;
  },

  // 인터넷 커머스 신청서 작성 - 사용자
  async [internet.CREATE_INTERNET_COMMERCE_APPLY_SUBMIT](context, params) {
    const { data } = await InternetService.createApplySubmit(params);
    return data;
  },

  // 인터넷 커머스 가입신청내역 (사용자)
  async [internet.SELECT_INTERNET_COMMERCE_APPLY_LIST](context, params) {
    const { data } = await InternetService.getApplyList(params);
    context.commit(internet.SET_INTERNET_COMMERCE_APPLY_LIST, data);
    return data;
  },

  // 인터넷 커머스 가입신청내역 (사장님)
  async [internet.SELECT_OWNER_INTERNET_COMMERCE_APPLY_LIST](context, params) {
    const { data } = await InternetService.getOwnerApplyList(params);
    context.commit(internet.SET_INTERNET_COMMERCE_APPLY_LIST, data);
    return data;
  },

  // 인터넷 커머스 접수내역 (새로운신청 개수) (사장님)
  async [internet.SELECT_INTERNET_COMMERCE_APPLY_NEW_COUNT](context, params) {
    const { data } = await InternetService.getApplyNewCount(params);
    context.commit(internet.SET_INTERNET_COMMERCE_APPLY_NEW_COUNT, data);
    return data;
  },

  // 인터넷 커머스 예상지원금과 예상월요금
  async [internet.SELECT_INTERNET_COMMERCE_FORECAST](context, params) {
    const { data } = await InternetService.getSupportForecast(params);
    context.commit(internet.SET_INTERNET_COMMERCE_FORECAST, data);
    return data;
  },

  // 인터넷 다이렉트 신청서 보내기 - 사용자
  async [internet.CREATE_INTERNET_DIRECT_SUBMIT](context, params) {
    const { data } = await InternetService.createDirectSubmit(params);
    return data;
  },

  // 인터넷 채팅방 신청서 리스트
  async [internet.SELECT_INTERNET_CHAT_QUOTATION_LIST](context, params) {
    const { data } = await InternetService.getChatQuotationList(params);
    console.log('[SELECT_INTERNET_CHAT_QUOTATION_LIST]');
    console.log(data);
    context.commit(internet.SET_INTERNET_CHAT_QUOTATION_LIST, data);
    return data;
  },

  // 인터넷 기획전 신청
  async [internet.CREATE_INTERNET_PROMOTION_SUBMIT](context, params) {
    await InternetService.createPromotionSubmit(params);
  },

  // 나에게 맞는 인터넷
  async [internet.SELECT_INTERNET_PRODUCTS](context, params) {
    const { data } = await InternetService.getInternetProducts(params);
    return data;
  },
  // 상품 찜하기 / 찜해제
  async [internet.UPDATE_INTERNET_BOOKMARK](contenxt, params) {
    const { data } = await InternetService.setBookmark(params);
    return data;
  },
  //상품 조회 처리 (카운트 증가)
  async [internet.UPDATE_INTERNET_VIEW_PRODUCT](context, params) {
    await InternetService.setViewProductCnt(params);
  },
  //상품 견적 요청처리 (카운트 증가)
  async [internet.UPDATE_INTERNET_SEL_PRODUCT](context, params) {
    await InternetService.setSelProductCnt(params);
  },

  // 신청서가 열람되었는지 확인
  async [internet.SELECT_INTERNET_APPLY_CHECK_LIMIT](context, params) {
    const { data } = await InternetService.getApplyCheckLimit(params);
    return data;
  },

  // 인터넷 커머스 프로모션
  async [internet.FETCH_INTERNET_COMMERCE_PROMOTION](context, params) {
    const { data } = await InternetService.getInternetCommercePromotion(params);
    return data;
  },

  // 인터넷 커머스 프로모션 상세
  async [internet.FETCH_INTERNET_COMMERCE_PROMOTION_DETAIL](context, params) {
    const { data } = await InternetService.getInternetCommercePromotionDetail(
      params,
    );
    return data;
  },

  // 인터넷 커머스 프로모션 지원금
  async [internet.FETCH_INTERNET_COMMERCE_PROMOTION_SUPPORT](context, params) {
    const { data } = await InternetService.getInternetCommercePromotionSupport(
      params,
    );
    return data;
  },

  // 인터넷 신청서 동일 명의자 중복 여부 확인(사용자)
  async [internet.SELECT_INTERNET_APPLY_VALIDATE](context, params) {
    const { data } = await InternetService.getApplyValidate(params);
    return data;
  },

  // 인터넷 신청서 동일 명의자 중복 여부 확인(사장님)
  async [internet.SELECT_INTERNET_APPLY_CHECK_VALIDATE](context, params) {
    const { data } = await InternetService.getApplyCheckValidate(params);
    return data;
  },

  // 인터넷 프로모션 kt
  async [internet.UPDATE_INTERNET_COMMERCE_PROMOTION_CHAT](context, params) {
    const { data } = await InternetService.internetCommercePromotionChat(
      params,
    );
    return data;
  },

  // 인터넷 신청서 취소
  async [internet.SET_INTERNET_APPLY_CANCEL](context, params) {
    const { data } = await InternetService.internetCommerceApplyCancel(params);
    return data;
  },

  // 인터넷 알림톡으로 들어온 신청 리스트
  async [internet.SELECT_INTERNET_SUPPORT_APPLY_LIST](context, params) {
    const { data } = await InternetService.internetCommerceSupportApplyList(
      params,
    );
    return data;
  },

  // 간략한 신청 정보
  async [internet.SELECT_INTERNET_APPLY_LIST_SIMPLE](context, params) {
    const { data } = await InternetService.internetCommerceApplyListSimple(
      params,
    );
    return data;
  },

  // 인터넷 설치일 변경
  async [internet.UPDATE_INTERNET_APPLY_INSTALL_DATE](context, params) {
    const { data } = await InternetService.setInternetCommerceApplyInstallDate(
      params,
    );
    return data;
  },

  // 인터넷 설치일 변경
  async [internet.UPDATE_INTERNET_APPLY_DEPOSIT](context, params) {
    const { data } = await InternetService.setInternetCommerceApplyDeposit(
      params,
    );
    return data;
  },

  // 인터넷 설치비
  async [internet.SELECT_INTERNET_COMMERCE_INSTALL_COST](context, params) {
    const { data } = await InternetService.internetCommerceInstallCost(params);
    return data;
  },

  // 인터넷 새로운 상품 리스트
  async [internet.SELECT_INTERNET_COMMERCE_ITEMS](context, params) {
    const { data } = await InternetService.internetCommerceItems(params);
    return data;
  },

  // 나의 요금 상품 등록하기
  async [internet.INSERT_INTERNET_COMMERCE_ITEMS](context, params) {
    const { data } = await InternetService.insertInternetCommerceItems(params);
    return data;
  },

  // 나의 인터넷 요금 상품 리스트
  async [internet.SELECT_INTERNET_COMMERCE_MY_ITEMS](context, params) {
    const { data } = await InternetService.internetCommerceMyItems(params);
    return data;
  },

  // 나의 인터넷 요금 상품 삭제
  async [internet.DELETE_INTERNET_COMMERCE_MY_ITEMS](context, params) {
    const { data } = await InternetService.deleteCommerceMyItems(params);
    return data;
  },

  // 나의 인터넷 요금 상품 정렬
  async [internet.UPDATE_INTERNET_COMMERCE_MY_ITEMS_SORT](context, params) {
    const { data } = await InternetService.updateCommerceMyItemsSort(params);
    return data;
  },

  // 인터넷 견적 요청서 건수
  async [internet.SELECT_INTERNET_REQUEST_CNT](context, params) {
    const { data } = await InternetService.getInternetRequestCnt(params);
    return data;
  },

  // 인터넷 동일 견적 동시 보내기
  async [internet.SELECT_INTERNET_COMMERCE_SAME_COUNT](context, params) {
    const { data } = await InternetService.getInternetSameCnt(params);
    return data;
  },
};

export default actions;
